import { useEffect, useRef } from 'react';
import QrScanner from 'qr-scanner'; 
import styles from './Scanner.module.scss';

export default function Scanner({ onScan }) {

  const video = useRef(null);
  const scanner = useRef(null);

  useEffect(() => {
    if (scanner.current) {
      return;
    }

    scanner.current = new QrScanner(video.current, ({data}) => {
      console.log('decoded qr code:', data);
      onScan(data?.replace('https://ride.goxapp.com/', ''));
      scanner.current.stop();
    });

    scanner.current.start();

    return () => {
      scanner.current.stop();
    }
  }, []);

  return (
    <div className={styles.container}>
      <video ref={video} className={styles.video} />
    </div>
  );
};
